<template>
  <span :class="'badge badge-' + variant">{{ label }}</span>
</template>

<script>
export default {
  name: 'OrderStatusBadge',
  props: {
    status: {
      type: String,
      default: null
    },
    sentToFulfillService: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    variant() {
      const map = {
        on_hold: 'secondary',
        open: 'primary',
        awaiting_shipment: 'warning',
        shipping: 'warning',
        shipped: 'success',
        cancelled: 'danger',
        awaiting_payment: 'danger',
        pending_fulfillment: 'danger'
      };
      return map[this.status] || 'primary';
    },
    label() {
      const map = {
        on_hold: 'On Hold',
        open: 'Open',
        awaiting_shipment: 'Awaiting Shipment' + (this.sentToFulfillService ? ' [at fulfillment]' : ''),
        shipping: 'Shipping',
        shipped: 'Shipped',
        cancelled: 'Canceled',
        awaiting_payment: 'Awaiting Payment',
        pending_fulfillment: 'Pending Fulfillment'
      };
      return map[this.status] || (this.status || 'Unknown');
    }
  }
};
</script>
